import React, { Fragment, memo, useState, useRef, useEffect } from 'react';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ToggleButtonUrl from './images/toggle-button.svg';
import ShareIconUrl from './images/share-icon.svg';
import MetadataTitle from './metadata-title';
import MetadataDescription from './metadata-description';
import MetadataDateDuration from './metadata-date-duration';
import MetadataTags from './metadata-tags';
import ShareModal from '../share-modal';

const Metadata = (props) => {

    const {
        id,
        image,
        title,
        description,
        date,
        duration,
        onMetadataToggle,
        tags,
        onShare,
        shareModalConfig,
        dictionary,
    } = props;

    const [
        collapse,
        setCollapse,
    ] = useState(true);

    const [
        modalVisibility,
        setModalVisibility,
    ] = useState(false);

    const [
        modalJustClosed,
        setModalJustClosed,
    ] = useState(false);

    useEffect(() => {

        modalJustClosed ? shareButtonRef.current.focus() : null;

    }, [modalJustClosed]);

    const shareButtonRef =  useRef(null);

    const onMetadataButtonClick = () => {

        // Just fire analytics call when expanding metadata
        if (collapse) {

            onMetadataToggle();

        }

        setCollapse(!collapse);

    };

    const onShareButtonClick = (event) => {
        const target = (event.currentTarget) ? event.currentTarget :  event.current;
        onShare(target.getAttribute('data-type'));
    };

    const metadataClassNames = classNames({
        'metadata': true,
        'metadata--expanded': !collapse,
    });

    const openShareModal = (e) => {
        e.stopPropagation();
        setModalVisibility(true);
        setModalJustClosed(false);
        onShare('Share');
    }
    const shareText = _get(dictionary, 'share_text', 'Share');

    const onModalDismiss = () => {

        setModalVisibility(false);
        setModalJustClosed(true);
    };

    return (
        <Fragment>
            <div className={metadataClassNames}>
                <button className="metadata__toggle-button" onClick={() => onMetadataButtonClick()}>
                    <img
                        src={ToggleButtonUrl}
                        alt="Toggle Icon"
                    />
                </button>
                <MetadataTitle title={title} />
                <MetadataDateDuration date={date} duration={duration} />
                <button
                    onClick={openShareModal}
                    className="metadata__share-button"
                    ref={shareButtonRef}
                >
                    <img
                        className="metadata__share-button__icon"
                        alt="{shareText}"
                        src={ShareIconUrl}
                    />
                    {shareText}
                </button>
                <MetadataDescription description={description} />
                <MetadataTags tags={tags} />
            </div>
            { modalVisibility &&
                <ShareModal
                    content={{
                        id,
                        title,
                        description,
                        image,
                        url: __CLIENT__ ? window.location.href : 'https://www.mlb.com',
                        embedElement: shareModalConfig.embedElement || null
                    }}
                    visible={modalVisibility}
                    onShareButtonClick={onShareButtonClick}
                    onModalDismiss={onModalDismiss}
                    dictionary={dictionary}
                />
            }
        </Fragment>
    );

};

Metadata.propTypes = {
    id: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    date: PropTypes.string,
    duration: PropTypes.string,
    onMetadataToggle: PropTypes.func,
    onShare: PropTypes.func,
    tags: PropTypes.array,
    shareModalConfig: PropTypes.object,
    dictionary: PropTypes.object,
};

Metadata.defaultProps = {
    onMetadataToggle: _noop,
    onShare: _noop,
    shareModalConfig: {},
    dictionary: {},
};

export default memo(Metadata);
